module.exports = "pegasus_template/assets/preview-18.png";